// @flow
import type { StoreResourceDef } from 'app/core/types'

export const contractSecureDatas: StoreResourceDef<> = {
  resourceType: 'contractSecureDatas',
}
